import { MAIN_PATH } from 'cpmCarparks/navigation';

const indexComponent = require('./routes/list/components/CarparksList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: MAIN_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/show'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparksManager'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/index.js